'use strict';

/** Definição de onde os arquivos contendo as chaves de tradução estão localizados. */
import { TRANSLATE_KEYS_PT_BR } from '@/i18n/pt_BR.js';
import { TRANSLATE_KEYS_ES_ES } from '@/i18n/es_ES.js';
import { TRANSLATE_KEYS_EN_US } from '@/i18n/en_US.js';

export default class ImplyTranslate {
  /**
   * Retorna a linguagem atual selecionada.
   * @return {string}
   */
  getCurrentLang() {
    const VALID_LANGS = ['pt', 'en', 'es'];
    const currentLang = localStorage.getItem('language');

    if (currentLang != null && VALID_LANGS.includes(currentLang)) {
      return currentLang;
    }

    const browserLanguage = navigator.language || navigator.userLanguage;

    if (browserLanguage.includes('pt')) {
      return 'pt';
    } else if (browserLanguage.includes('en')) {
      return 'en';
    } else if (browserLanguage.includes('es')) {
      return 'es';
    }

    return 'pt';
  }

  /**
   * Retorna a linguagem atual selecionada completa.
   * @return {string}
   */
  getCurrentLangFull() {
    const currentLang = this.getCurrentLang();

    switch (currentLang) {
      case 'pt':
        return 'pt_BR';
      case 'en':
        return 'en_US';
      case 'es':
        return 'es_ES';
      default:
        return 'pt_BR';
    }
  }

  /**
   * Método que realiza a tradução das chaves.
   * @param {string} translateKey
   * @return {string} - chave traduzida.
   */
  _t(translateKey) {
    const language = this.getCurrentLang();

    const lang = localStorage.getItem('language');

    if (lang == null || lang == undefined) {
      localStorage.setItem('language', language);
    }

    switch (language) {
      case 'pt':
        if (translateKey in TRANSLATE_KEYS_PT_BR) {
          return TRANSLATE_KEYS_PT_BR[translateKey] == '' ||
          TRANSLATE_KEYS_PT_BR[translateKey] == null
            ? translateKey
            : TRANSLATE_KEYS_PT_BR[translateKey];
        } else {
          return '{??' + translateKey + '??}';
        }
      case 'en':
        if (translateKey in TRANSLATE_KEYS_EN_US) {
          return TRANSLATE_KEYS_EN_US[translateKey] == '' ||
          TRANSLATE_KEYS_EN_US[translateKey] == null
            ? translateKey
            : TRANSLATE_KEYS_EN_US[translateKey];
        } else {
          return '{??' + translateKey + '??}';
        }
      case 'es':
        if (translateKey in TRANSLATE_KEYS_ES_ES) {
          return TRANSLATE_KEYS_ES_ES[translateKey] == '' ||
          TRANSLATE_KEYS_ES_ES[translateKey] == null
            ? translateKey
            : TRANSLATE_KEYS_ES_ES[translateKey];
        } else {
          return '{??' + translateKey + '??}';
        }
    }

    return 'Nenhuma chave ou idioma encontrado(a).';
  }
}
